import Colours from './colours';

const postStyle = {
  chip: {
    border:       'solid',
    borderColor:  Colours.Primary,
    borderRadius: '30,',
    borderWidth:  1,
    fontSize:     12,
  },
  paper: {
    flexGrow: 1,
    margin:   'auto',
    maxWidth: '100%',
    padding:  '20px 30px',
  },
  textHeader: {
    color: Colours.Black,
    fontSize:13
  },
};

export default postStyle;
